import {isLoggedIn} from 'utils/auth'

export default (store) => {
  return ({
    path: 'user-list',
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure([], (require) => {
        const userListing = require('./UserListing').default
        cb(null, userListing)
      }, 'UserListing')
    }
  })
}



// WEBPACK FOOTER //
// ./src/routes/UserListing/index.js